import { Analytics } from "@mui/icons-material";
import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "../../../../store/rootReducer";
import {
  selectPropertyById,
  selectPropertyDocuments,
} from "../../../properties/store/propertiesSelectors";
import { BaseToolResult } from "./BaseToolResult";
import { ToolExecutingProps } from "./toolLoadingRegistry";

export const PropertyInsightsExecuting: React.FC<ToolExecutingProps> = () => {
  const { id } = useParams<{ id: string }>();
  const property = useSelector((state: RootState) =>
    selectPropertyById(state, id || "")
  );
  const documents = useSelector((state: RootState) =>
    property
      ? selectPropertyDocuments(state, {
          address: property.address,
          strataPlanNumber: property.strataPlanNumber,
        })
      : []
  );

  const documentCount = documents.length;

  return (
    <BaseToolResult icon="🏠">
      <Box
        sx={{
          borderRadius: 1,
          p: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: "bold", color: "success.main", mb: 1 }}
        >
          Researching Strata Property Documents
        </Typography>

        <LinearProgress
          color="success"
          sx={{
            borderRadius: 1,
            height: 4,
            backgroundColor: "success.100",
            mb: 2,
          }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Analytics fontSize="small" color="action" />
          <Typography variant="caption" color="text.secondary">
            Checking {documentCount} documents and insights for relevant
            information...
          </Typography>
        </Box>
      </Box>
    </BaseToolResult>
  );
};
